import './template.scss';
import { INSTALLMENT_INSTALL } from './template';
import AppLibrary from './app-library';
import renderTemplate from './renderTemplate';

export class Application {

  #library;

  #config;

  /**
   *
   * @param {AppConfig} config
   * @param {AppLibrary} library
   * @param {string} page
   */
  constructor(config, library, page) {
    this.#config = config;
    this.#library = library;

    const {settings} = this.#config.settings();

    const widgetPlacement = document.querySelector(settings.selector_widget.selector);
    if (!widgetPlacement) {
      throw new Error('Can not find widget placement');
    }
    document.addEventListener('click', (e) => this.#addToCartClick(e), true);
    this.#insertWidget(widgetPlacement, settings.selector_widget);
  }

  /**
   *
   * @returns {string}
   */
  #getWidget() {
    const {settings} = this.#config.settings();
    const {widget_texts} = settings;

    return renderTemplate(
      widget_texts.option_full,
      widget_texts.option_installment,
      settings.installment_months,
      widget_texts.installment_tip,
      widget_texts.initial_payment,
      settings.installment_first_pay
    );
  }

  /**
   * @param {Element} placement
   * @param {object} selector
   */
  #insertWidget(placement, selector) {
    const div = document.createElement('div');
    div.innerHTML = this.#getWidget();

    if (selector.position === 'before') {
      placement.parentNode.insertBefore(div, placement);
    } else if (selector.position === 'after') {
      placement.parentNode.insertBefore(div, placement.nextSibling);
    } else {
      throw new Error('Invalid type of selector position');
    }
  }

  /**
   * @param e
   */
  #addToCartClick(e) {
    const {settings} = this.#config.settings();

    let isAtcClicked = e.target.matches(settings.selector_atc.selector);
    if (!isAtcClicked) {
      document.querySelectorAll(settings.selector_atc.selector).forEach((node) => {
        if (node.contains(e.target)) {
          isAtcClicked = true;
        }
      })
    }
    if (!isAtcClicked) {
      return;
    }

    const installmentInput = document.querySelector('input[name="installment"]:checked');
    if (installmentInput && installmentInput.value === INSTALLMENT_INSTALL) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.#createDraftorder(e.target);
    }
  }

  #createDraftorder(buttonElement) {
    const {settings} = this.#config.settings();
    const snippet = this.#config.snippet();
    const env = this.#config.env();

    Spurit.global.atc.lineItemByTargetElement(buttonElement, lineItem => {
      if (!lineItem) {
        return;
      }

      let item = {
        quantity: lineItem.quantity,
        variant_id: lineItem.id,
        properties: lineItem.properties
      };

      let discountPercentage = 100 - settings.installment_first_pay;

      let discount = {
        value_type: 'percentage',
        value: (discountPercentage < 100) ? discountPercentage : 100,
        // amount: Snippet.isNonFractionalCurrency ? //todo fractional, мб это в глобале надо сделать
        //   Utils.round(fullPrice * quantity * percentage / 100, 0) :
        //   Utils.floor(fullPrice * quantity * percentage / 100, Snippet.orderDiscountPrecision),
        amount: Math.floor(snippet.productPrice * lineItem.quantity * discountPercentage / 100)
      };
      if (discount) {
        discount.title = 'Discount';
        item.applied_discount = discount;
      }

      buttonElement.style.cursor = 'progress';

      const cartData = {line_items: [item]};
      const options = {tags: env.installmentTag};
      const pauseBeforeRedirect = 1000;

      Spurit.global.checkout.submitCustomDraftOrder(cartData, options)
        .then(response => {
          if (response.draft_order && response.draft_order.invoice_url) {
            setTimeout(() => {
              buttonElement.style.cursor = '';
              location.href = response.draft_order.invoice_url;
            }, pauseBeforeRedirect)
            // location.href = response.draft_order.invoice_url;
          } else {
            buttonElement.style.cursor = '';
          }
        }).catch(() => {
          buttonElement.style.cursor = '';
        });

    });
  }
}